import createApiServices from "./createApiServices"

const prefixURL = process.env.REACT_APP_URL_3D_PARTNER ? `${process.env.REACT_APP_URL_3D_PARTNER}` : 'https://tool3d-partner-staging.merchize.com/api/partner'
const api = createApiServices({baseUrl: prefixURL})

export const updateStatusItemEmbroidery = (data) => {
    return api.makeAuthRequest({
        url: '/batches/status/embroidery',
        method: 'POST',
        data,
    })
}